import apiClient from '../../../Services/ApiClient';
import {
	WizardAction,
	WizardItem,
	WizardRootItem,
} from '../Interfaces/Wizard.interface';
import { WizardActionType } from '../Enums/WizardActionType.enum';
import { WizardActionDestination } from '../Enums/WizardActionDestination.enum';
import { WizardItemType } from '../Enums/WizardItemType.enum';
import { WizardItemSubType } from '../Enums/WizardItemSubtype.enum';

export const checkWizardExist = async (
	key: string,
	initialData?: object,
): Promise<boolean> => {
	try {
		const response = await apiClient.post(`/wizard/${key}/tree`, initialData);
		return !!response.data;
	} catch (e) {
		console.log('WIZARD DOESNT EXIST!');
	}
	return false;
};

export const resolveWizardAction = (action: WizardAction) => {
	if (action.type !== WizardActionType.REDIRECT) {
		return;
	}

	if (action.destination === WizardActionDestination.HOMEPAGE) {
		window.location.href = '/domu/';
		return;
	}

	if (action.destination === WizardActionDestination.MEASUREMENT_HISTORY) {
		window.location.href = `/measurement-history/${action.wizardKey}`;
		return;
	}

	if (action.destination === WizardActionDestination.BROWSER && action.url) {
		window.location.href = action.url;
		return;
	}

	if (action.destination === WizardActionDestination.CREATE_CASE) {
		const params = new URLSearchParams();

		if (action.initialData !== undefined) {
			params.set('initialData', JSON.stringify(action.initialData));
		}

		if (action.initStep !== undefined) {
			params.set('initStep', action.initStep);
		}

		const query = params.toString();

		window.location.href = `/case-wizard/react-new-case/${
			query ? `?${query}` : ''
		}`;
		return;
	}

	if (action.destination === WizardActionDestination.WIZARD_ONLINE) {
		const params = new URLSearchParams();

		if (action.initialData !== undefined) {
			params.set('initialData', JSON.stringify(action.initialData));
		}

		const query = params.toString();

		window.location.href = `/wizard/${action.wizardId}${
			query ? `?${query}` : ''
		}`;
		return;
	}
};

export const getWizardStepTitleItem = (
	step: WizardRootItem,
): Extract<WizardItem, { type: WizardItemType.TEXT }> => {
	return {
		id: `step-title-${step.id}`,
		key: `step-title-${step.key}`,
		parentId: step.id,
		rank: -2,
		title: step.title,
		wizardId: step.wizardId,
		type: WizardItemType.TEXT,
		subtype: WizardItemSubType.HEADER,
		data: null,
		settings: {
			style: { ...step.settings?.title, marginBottom: '10px' },
		},
		children: null,
		value: undefined,
	};
};

export const getWizardStepDescriptionItem = (
	step: WizardRootItem,
): Extract<WizardItem, { type: WizardItemType.TEXT }> => {
	return {
		id: `step-description-${step.id}`,
		key: `step-description-${step.key}`,
		parentId: step.id,
		rank: -1,
		title: step.description!,
		wizardId: step.wizardId,
		type: WizardItemType.TEXT,
		subtype: WizardItemSubType.NORMAL,
		data: null,
		settings: {
			style: step.settings?.description,
		},
		children: null,
		value: undefined,
	};
};
